module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_8017.1cee0f5b.png";